module.exports = __webpack_public_path__ + "static/img/yuangong1.9b36ddaf.png";